module.exports = {
    config: require('./config'),
    procedures:{
        project_create:{
            definition: require('./project_create/definition.json'),
            mock_data:require('./project_create/mock_data.json')
        },
        project_list:{
            definition: require('./project_list/definition.json'),
            mock_data:require('./project_list/mock_data.json')
        },
        task_change_log_list:{
            definition: require('./task_change_log_list/definition.json'),
            mock_data:require('./task_change_log_list/mock_data.json')
        },
        task_list:{
            definition: require('./task_list/definition.json'),
            mock_data:require('./task_list/mock_data.json')
        },
        task_create:{
            definition: require('./task_create/definition.json'),
            mock_data:require('./task_create/mock_data.json')
        },
        task_selector_list:{
            definition: require('./task_selector_list/definition.json'),
            mock_data:require('./task_selector_list/mock_data.json')
        },
        task_read:{
            definition: require('./task_read/definition.json'),
            mock_data:require('./task_read/mock_data.json')
        },
        task_update:{
            definition: require('./task_update/definition.json'),
            mock_data:require('./task_update/mock_data.json')
        },
        time_log_delete:{
            definition: require('./time_log_delete/definition.json'),
            mock_data:require('./time_log_delete/mock_data.json')
        },
        time_log_list:{
            definition: require('./time_log_list/definition.json'),
            mock_data:require('./time_log_list/mock_data.json')
        },
        time_log_read:{
            definition: require('./time_log_read/definition.json'),
            mock_data:require('./time_log_read/mock_data.json')
        },
        time_log_create:{
            definition: require('./time_log_create/definition.json'),
            mock_data:require('./time_log_create/mock_data.json')
        },
        time_log_update:{
            definition: require('./time_log_update/definition.json'),
            mock_data:require('./time_log_update/mock_data.json')
        },
        time_log_selector_list:{
            definition: require('./time_log_selector_list/definition.json'),
            mock_data:require('./time_log_selector_list/mock_data.json')
        },
        code_repo_log_create:{
            definition: require('./code_repo_log_create/definition.json'),
            mock_data:require('./code_repo_log_create/mock_data.json')
        },
        code_repo_log_list:{
            definition: require('./code_repo_log_list/definition.json'),
            mock_data:require('./code_repo_log_list/mock_data.json')
        }
    }
};
